module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "TokenGenesis",
    "md5": "fdd5eb8fb7495932fec9850306fd6fb0",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TokenProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "Backtrace",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "pubKey",
                    "type": "PubKey"
                },
                {
                    "name": "sig",
                    "type": "Sig"
                },
                {
                    "name": "tokenScript",
                    "type": "bytes"
                },
                {
                    "name": "genesisTxHeader",
                    "type": "bytes"
                },
                {
                    "name": "prevInputIndex",
                    "type": "int"
                },
                {
                    "name": "genesisTxInputProof",
                    "type": "TxInputProof"
                },
                {
                    "name": "prevGenesisTxHeader",
                    "type": "bytes"
                },
                {
                    "name": "prevTxOutputHashProof",
                    "type": "bytes"
                },
                {
                    "name": "prevTxOutputSatoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "genesisSatoshis",
                    "type": "int"
                },
                {
                    "name": "tokenSatoshis",
                    "type": "int"
                },
                {
                    "name": "changeAddress",
                    "type": "Ripemd160"
                },
                {
                    "name": "changeSatoshis",
                    "type": "int"
                },
                {
                    "name": "opReturnScript",
                    "type": "bytes"
                }
            ]
        },
        {
            "type": "constructor",
            "params": []
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract/token/tokenGenesis.scrypt",
    "hex": "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",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract-desc/tokenGenesis.map.json"
}